// extracted by mini-css-extract-plugin
export default {"section":"Experience_section__ALHqd","heading":"Experience_heading__JU0Nj","cards":"Experience_cards__pKG+Q"};